var _rect, _rect2, _rect3, _rect4, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.47 29.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TISSOT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.47,
    height: 29.47,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.98,
    width: 29.47,
    height: 29.47,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.94,
    y: 0.94,
    width: 27.6,
    height: 27.6,
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.92,
    y: 0.94,
    width: 27.6,
    height: 27.6,
    fill: "#ff0000"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "57 11.7 49.76 11.7 49.76 4.46 43.68 4.46 43.68 11.7 36.45 11.7 36.45 17.77 43.68 17.77 43.68 25.01 49.76 25.01 49.76 17.77 57 17.77 57 11.7",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "25.01 4.46 4.46 4.46 4.46 9.22 11.55 9.22 11.55 25.01 17.93 25.01 17.93 9.22 25.01 9.22 25.01 4.46",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e6409a831b5665c436cb5577a9594d09.svg";
export { ForwardRef as ReactComponent };